
var controller = (function() {
	var obj = {
		init: function() {
			this.instanceReadyController.init.call(this.instanceReadyController);
		},
		instanceReadyController: {
			queue: [],
			addListener: function(context, id) {
				if (this.getListener(context, id)) {
					this.removeListener(context, id);
				}
				this.queue.push({
					context: context, 
					id: id
				})
			},
			removeListener: function(context, id) {
				var listener = this.getListener(context, id);
				if (!listener) return;
				var index = this.queue.indexOf(listener);
				this.queue.splice(index, 1);
			},
			getListener: function(context, id) {
				var result;
				this.queue.some(function(el) {
					if (el.id == id) {
						result = el;
						return true;
					}
					return false;
				});
				return result;
			},
			notify: function(id) {
				var listener = this.getListener(null, id);
				if (!listener) return;
				if (!listener.context) return;
				this.removeListener(listener.context, id);
				listener.context["instanceReady"].call(listener.context);
			},
			init: function() {
				var that = this;
				window.CKEDITOR.on('instanceReady',function(event){
				 	var id = event.editor.name;
				 	that.notify.call(that, id);
			 	});
			}
		},
		utils: {
			encode: function(str) {
				str = str.replace(/\"/g, "$$").replace(/\'/g, "$$");
				try {
					str = encodeURIComponent(str);
				} catch(e) {}
				return str;
			},
			decode: function(str) {
				try {
					str = decodeURIComponent(escape(str));
				} catch(e) {}
				str = str.replace(/\$/g, "\"");
				return str;
			}
		}
	}
	obj.init();
	return {
		addInstanceReadyListener: obj.instanceReadyController.addListener.bind(obj.instanceReadyController),
		removeInstanceReadyListener: obj.instanceReadyController.removeListener.bind(obj.instanceReadyController),
		utils: obj.utils
	};
})();


export default controller;


// WEBPACK FOOTER //
// ./src/coms/rich/Controller.js